import { createGetOneHook } from '@/utils/createGetOneHook';
import { createFieldsHook } from '@/utils/createFieldsHook';
import UserApiService from '@/modules/admin/services/UserApiService';
import { CACHE_KEY_USER, fields } from '@/modules/admin/contants/users';
import { FilterFactory, TermFilter } from '@dofleini/query-builder';

import { client } from '@ahab/oficinav-commons';
import { useQueries } from 'react-query';

export const useGetOneUser = createGetOneHook(
  UserApiService,
  'id',
  CACHE_KEY_USER,
);

export const useFields = createFieldsHook('admin', fields);

export const useUserByTypes = (filters, search) => {
  const queries = Object.keys(client.CLIENT_TYPE)?.map((type) => ({
    queryKey: [CACHE_KEY_USER, type, filters, search],
    queryFn: async () => {
      const { data } = await UserApiService.count({
        search,
        filters: FilterFactory.add(filters, new TermFilter({ field: 'clientType', value: type })).toQuery(),
      });
      return { [type]: data?.total };
    },
    refetchOnWindowFocus: true,
    keepPreviousData: true,
  }));
  
  console.log(queries);
  
  const responses = useQueries(queries);
  
  return {
    data: responses.map((r) => {
      return r?.data;
    })?.reduce((r, e) => {
      return ({ ...r, ...e });
    }, {}),
    isLoading: responses.some(e => e?.isLoading),
  };
};
